export const TEMP_LEAVE_TYPES = [
  { id: 1, label: "Holiday" },
  { id: 2, label: "Sick Leave" },
  { id: 3, label: "Compassionate Leave" },
] as const;
